export const formatCount = (num) => {
  const value = Number(num) || 0;
  if (value < 10000) return String(value);
  if (value < 100000) return `${(value / 10000).toFixed(1).replace(/\.0$/, '')}万`;
  return `${Math.floor(value / 10000)}万`;
};

export const stripHtml = (html = '') => String(html)
  .replace(/<[^>]+>/g, '')
  .replace(/(?:&nbsp;|&#160;|&#xa0;|\u00a0)/gi, ' ');

export const truncateText = (text = '', max = 50) => {
  const chars = Array.from(String(text));
  return chars.length > max ? `${chars.slice(0, max).join('')}...` : chars.join('');
};
